import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { action } from 'satcheljs';
import type { QuickComposeViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import type {
    FullComposeEntrySourceType,
    QuickComposeEntrySourceType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import EventScope from 'owa-service/lib/contract/EventScope';

export const resetFullCompose = action(
    'resetFullCompose',
    (
        formId: string,
        entrySource: FullComposeEntrySourceType,
        event: Partial<CalendarEvent>,
        eventScope?: EventScope
    ) => ({
        formId,
        entrySource,
        event,
        eventScope,
    })
);

export const resetFullComposeToChangeSeriesEditScope = action(
    'resetFullComposeToChangeSeriesEditScope',
    (
        formId: string,
        targetWindow: Window,
        entrySource: FullComposeEntrySourceType,
        eventScope: EventScope
    ) => ({
        formId,
        targetWindow,
        entrySource,
        eventScope,
    })
);

export const resetQuickCompose = action(
    'resetQuickCompose',
    (
        event: CalendarEvent,
        entrySource: QuickComposeEntrySourceType,
        viewType: QuickComposeViewType,
        anchor: HTMLDivElement | string,
        formId: string
    ) => ({
        event,
        entrySource,
        viewType,
        anchor,
        formId,
    })
);
